import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { Tc } from '../../../../core/_infrastructure/types/common';
import { DeclaracionSuplementariaService } from '../declaracionsuplementaria.service';
import { TDeclaracionSuplementariaViewModel } from '../declaracionsuplementaria.types';

@Component({
    selector: 'app-declaracionsuplementaria-wrapper-edit',
    templateUrl: './declaracionsuplementaria-wrapper-edit.component.html',
    styleUrls: ['./declaracionsuplementaria-wrapper-edit.component.scss'],
})
export class DeclaracionSuplementariaWrapperEditComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    declaracionSuplementaria: TDeclaracionSuplementariaViewModel;
    formGroup: FormGroup;

    messageErrorAlreadyExist = 'Ya existe esta Declaración Suplementaria';
    successMessage = 'Declaración Suplementaria guardada correctamente';
    listUrl = '/mantenimiento/general/declaracionsuplementaria';

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const id: any = params.get('id');
        if (id) {
            this.getDeclaracionSuplementaria(id);
        }
    });

    listCampanias: Tc[];
    listTipoTextoDeclaracionSuplementaria: Tc[];

    listCampanias$ = this.globalService.getAllCampanias().subscribe(params => {
        this.listCampanias = params;
    });

    lisTipoTextoDeclaracionSuplementaria$ = this.declaracionSuplementariaService.getTipoTextoDeclaracionSuplementaria().subscribe(params => {
        this.listTipoTextoDeclaracionSuplementaria = params;
    });

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private declaracionSuplementariaService: DeclaracionSuplementariaService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.preparePresentation();
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                Id: [null],
                IdCampania: [null, Validators.required],
                IdTipoTextoDecSuplementariaCam: [null, Validators.required],
                FechaCreacion: null,
                FechaBaja: null,
                Activa: true,
                DescripcionTexto: ['', Validators.required],
                TextoDecSuplementaria: ['', Validators.required],
                Observaciones: '',
            }),
        });
    }

    private getDeclaracionSuplementaria(id: number): void {
        this.declaracionSuplementariaService
            .getDeclaracionSuplementaria(id)
            .pipe(
                tap((d: TDeclaracionSuplementariaViewModel) => {
                    this.declaracionSuplementaria = d;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.formGroup.disable();
                    return of([]);
                }),
            )
            .subscribe();
    }

    onSave(): void {
        this.visibilitySpinner = true;
        const model = { ...this.formGroup.value.basic };

        model.FechaCreacion = this.declaracionSuplementaria?.FechaCreacion;
        model.FechaBaja = this.declaracionSuplementaria?.FechaBaja;

        this.declaracionSuplementariaService
            .saveDeclaracionSuplementaria(model)
            .pipe(
                tap(res => {
                    this.visibilitySpinner = false;
                    this.addSuccessMessage(this.successMessage);
                    this.onBack();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    if (error?.message?.indexOf(this.messageErrorAlreadyExist) != -1) {
                        this.formGroup.disable();
                    }
                    return of([]);
                }),
            )
            .subscribe();
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }

    get formInvalid(): boolean {
        return !this.formGroup.valid || !this.formGroup.dirty || this.formGroup.pristine;
    }
}
